module.exports = __webpack_public_path__ + "img/anquan_zhongji-1.4e1e825b.png";